import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import PageHeader from "../Common/PageHeader";
import HelpButton from "../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";
import {
  faCcApplePay,
  faCcMastercard,
  faCcPaypal,
  faCcVisa,
} from "@fortawesome/free-brands-svg-icons";

import BillingIcon from "../../assets/icons/payment_methods.svg2";
import ProgressIcon from "../../assets/icons/bulk_manage.svg2";
import CheckIcon from "../../assets/icons/tick.svg2";

function Checkout() {
  const [checkoutData, setCheckoutData] = useState({
    country: "United Kingdom ",
    name: "FPS Trial",
    address: "123 Fake Street",
    postcode: "LNI46LT",
    supportName1: "John Smith",
    supportEmail1: "john@smith.com",
    supportName2: "John Smith",
    supportEmail2: "john@smith.com",
    isSame: true,
  });
  const [paymentData, setPaymentData] = useState({
    payment: "New Card Details",
    nameOncard: "John Smith",
    cardNumber: "0000/ 0000/ 0000/ 0000",
    emailReceiptTo: "john@smith.com",
    isStored: true,
    isDefault: true,
    isAgree: true,
    isEmailReceiptTo: true,
  });
  const [billingData, setBillingData] = useState({
    annualSub: 0.0,
    connectionFee: 0.0,
    messageBank: 175,
    standartSupport: "FREE",
    totalData: 1350,
  });
  return (
    <>
      <PageHeader
        heading="Checkout"
        subheading="Lorem ipsum dolor sit amet consectetur adipisicing elit."
        className="bg-loop p-3 rounded-3"
      >
        <div className="d-flex align-items-center">
          <div className="fw-bold">Progress:</div>

          <div className="d-flex flex-column align-items-center">
            <div
              className=" bg-colored-reverse text-white rounded-circle p-2 position-relative z-1"
              style={{ width: 35, height: 35 }}
            >
              <ProgressIcon width={20} />
              <hr
                className="text-white border-3 opacity-100 position-absolute top-0 start-100"
                style={{ width: 70 }}
              />
            </div>
            <div className="small">Your selection</div>
          </div>
          <div style={{ width: 50 }}></div>
          <div className="d-flex flex-column align-items-center">
            <div
              className="bg-white text-navy  rounded-circle p-2 position-relative z-1"
              style={{ width: 35, height: 35 }}
            >
              <FontAwesomeIcon icon={faCreditCard} width={20} />
              <hr
                className="text-white border-3 opacity-25 position-absolute top-0 start-100"
                style={{ width: 60 }}
              />
            </div>
            <div className="small fw-bold">Billing</div>
          </div>
          <div style={{ width: 50 }}></div>

          <div className="d-flex flex-column align-items-center opacity-50 z-1">
            <div
              className="bg-purple-gradient text-purple opacity-25 rounded-circle p-2"
              style={{ width: 35, height: 35 }}
            >
              <CheckIcon width={20} />
            </div>
            <div className="small">Complete</div>
          </div>
        </div>
      </PageHeader>

      <div className="mb-4">
        <span className="fw-bold">Organisation and payment details.</span>
        <span className=" small">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit.
        </span>
      </div>

      <Row className="mb-5">
        <Col xs={12} xxl={4}>
          <div className="bg-colored-reverse text-white rounded-top-3 px-3 py-2 fw-bold">
            Organisation details:
          </div>
          <div className="bg-purple p-3 rounded-bottom-3">
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Country:*</div>
              <div className="col-9">
                <Form.Select
                  aria-label="checkout-country"
                  value={checkoutData.country}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      country: e.target.value,
                    });
                  }}
                >
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </div>
              <hr className="text-secondary  mt-2" />
            </Row>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Name:*</div>
              <div className="col-9">
                <Form.Control
                  type="text"
                  value={checkoutData.name}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      name: e.target.value,
                    });
                  }}
                />
              </div>
              <hr className="text-secondary mt-2" />
            </Row>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Address:*</div>
              <div className="col-9">
                <Form.Control
                  type="text"
                  value={checkoutData.address}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      address: e.target.value,
                    });
                  }}
                />
              </div>
              <hr className="text-secondary mt-2" />
            </Row>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Postcode:*</div>
              <div className="col-9">
                <Form.Control
                  type="text"
                  value={checkoutData.postcode}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      postcode: e.target.value,
                    });
                  }}
                />
              </div>
            </Row>
            <div className="text-navy bg-purple-gradient mb-2 fw-bold fs-6 px-3 rounded-2">
              Support Contact
              <HelpButton />
            </div>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Name:*</div>
              <div className="col-9">
                <Form.Control
                  type="text"
                  value={checkoutData.supportName1}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      supportName1: e.target.value,
                    });
                  }}
                />
              </div>
              <hr className="text-secondary mt-2" />
            </Row>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Email address:*</div>
              <div className="col-9">
                <Form.Control
                  type="email"
                  value={checkoutData.supportEmail1}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      supportEmail1: e.target.value,
                    });
                  }}
                />
              </div>
            </Row>
            <div className="text-navy bg-purple-gradient mb-2 fw-bold fs-6 px-3 rounded-2">
              Support Contact
              <HelpButton />
            </div>

            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Name:*</div>
              <div className="col-9">
                <Form.Control
                  type="text"
                  value={checkoutData.supportName2}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      supportName2: e.target.value,
                    });
                  }}
                />
              </div>
              <hr className="text-secondary mt-2" />
            </Row>
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Email address:*</div>
              <div className="col-9">
                {" "}
                <Form.Control
                  type="email"
                  value={checkoutData.supportEmail2}
                  onChange={(e) => {
                    setCheckoutData({
                      ...checkoutData,
                      SupportEmail2: e.target.value,
                    });
                  }}
                />
              </div>
            </Row>
            <div className="text-navy bg-purple-gradient mb-2 fw-bold fs-6 px-3 rounded-2">
              * Required field
            </div>
            <div className="mt-4">
              <Form.Check // prettier-ignore
                type="checkbox"
                id="organisation-checkbox"
                label="My organisation is the same as..."
                className="p-0"
                checked={checkoutData.isSame}
                onChange={() => {
                  setCheckoutData({
                    ...checkoutData,
                    isSame: !checkoutData.isSame,
                  });
                }}
              />
            </div>
            <div className="d-flex justify-content-end my-4">
              <button
                type="button"
                className="btn bg-colored-reverse text-white fw-bold p-1 px-3 rounded-pill"
              >
                SAVE
              </button>
            </div>
          </div>
        </Col>

        <Col xs={12} xxl={4}>
          <div className="bg-colored-reverse text-white rounded-top-3 px-3 py-2 fw-bold">
            Card payment via Stripe
          </div>
          <div className="bg-purple p-3 rounded-bottom-3">
            <Row className="mb-2">
              <div className="fw-bold mb-2 col-3">Payment:</div>
              <div className="col-9">
                <Form.Select
                  aria-label="payment-select"
                  value={paymentData.payment}
                  onChange={(e) => {
                    setPaymentData({
                      ...paymentData,
                      payment: e.target.value,
                    });
                  }}
                >
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </div>
              <hr className="text-secondary  mt-2" />
            </Row>
            <div className="bg-purple-gradient mb-2 p-4 rounded-3">
              <Row className="mb-2">
                <div className="fw-bold mb-2 fw-bold col-3 text-nowrap">Name on card:</div>
                <div className="col-9">
                  <Form.Control
                    type="text"
                    value={paymentData.nameOncard}
                    onChange={(e) => {
                      setPaymentData({
                        ...paymentData,
                        nameOncard: e.target.value,
                      });
                    }}
                  />
                </div>
                <hr className="text-secondary mt-2" />
              </Row>

              <Row className="mb-2">
                <div className="fw-bold mb-2 col-3 text-nowrap">Card number:</div>
                <div className="col-9 position-relative">
                  <Form.Control
                    type="text"
                    value={paymentData.cardNumber}
                    className="ps-5 fw-bold"
                    onChange={(e) => {
                      setPaymentData({
                        ...paymentData,
                        cardNumber: e.target.value,
                      });
                    }}
                  />
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    className="text-navy position-absolute start-0 top-50 translate-middle-y ms-4"
                  />
                </div>
                <hr className="text-secondary mt-2" />
                <div className="mt-4">
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id="payment-store-checkbox"
                    label="Store this card"
                    className="p-0"
                    checked={paymentData.isStored}
                    onChange={() => {
                      setPaymentData({
                        ...paymentData,
                        isStored: !paymentData.isStored,
                      });
                    }}
                  />
                </div>
                <div className="mt-4">
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id="payment-default-checkbox"
                    label="Make this card default payment method"
                    className="p-0"
                    checked={paymentData.isDefault}
                    onChange={() => {
                      setPaymentData({
                        ...paymentData,
                        isDefault: !paymentData.isDefault,
                      });
                    }}
                  />
                </div>
              </Row>
            </div>
            <div>
              <div className="mt-4">
                <Form.Check // prettier-ignore
                  type="checkbox"
                  id="payment-agree"
                  label="I agree to the Terms & Conditions"
                  className="p-0"
                  checked={paymentData.isAgree}
                  onChange={() => {
                    setPaymentData({
                      ...paymentData,
                      isAgree: !paymentData.isAgree,
                    });
                  }}
                />
              </div>
              <div className="fw-bold mb-2 mt-4">Email receipt to:</div>
              <div className="mt-2">
                <Form.Check // prettier-ignore
                  type="checkbox"
                  id="receipt-email"
                  label={paymentData.emailReceiptTo}
                  className="p-0"
                  checked={paymentData.isEmailReceiptTo}
                  onChange={() => {
                    setPaymentData({
                      ...paymentData,
                      isEmailReceiptTo: !paymentData.isEmailReceiptTo,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-end my-4">
                <button
                  type="button"
                  className="btn bg-colored-reverse text-white fw-bold p-1 px-3 rounded-pill"
                >
                  SUBMIT PAYMENT
                </button>
              </div>
            </div>
          </div>
          <div className="bg-colored-reverse text-white rounded-top-3 px-3 py-2 mt-4 fw-bold">
            Pay via Bank Transfer
          </div>
          <div className="bg-purple p-3 rounded-bottom-3">
            <div className="fw-bold mb-2 mt-2">
              Submit purchase to get bank reference
            </div>

            <div className="d-flex justify-content-start my-4">
              <button
                type="button"
                className="btn bg-colored-reverse text-white fw-bold p-1 px-3 rounded-pill"
              >
                SUBMIT PURCHASE
              </button>
            </div>
          </div>
        </Col>

        <Col xs={12} xxl={4} style={{ marginTop: -75 }}>
          <div className="bg-colored-reverse rounded-3 px-3 py-2 fw-bold">
            <div className="d-flex mb-5">
              <div className="rounded-circle m-3 p-2 bg-white">
                <BillingIcon width={30} />
              </div>
              <div>
                <div className="fs-2 text-white">Billing breakdown:</div>
                <div className="text-white opacity-50">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                </div>
              </div>
            </div>
            <div className="text-white p-3">
              <div className="d-flex justify-content-between">
                <div>Annual subscription </div>
                <div> £ {billingData.annualSub}</div>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <div>Connection fee </div>
                <div> £{billingData.connectionFee}</div>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <div>
                  Message Bank <div>(0.012 per message)</div>
                </div>
                <div> £ {billingData.messageBank}</div>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <div>Standart support </div>
                <div> {billingData.standartSupport}</div>
              </div>
              <hr />
            </div>
            <div className="text-white d-flex justify-content-center mb-5">
              <div className="text-center">
                <div className="fs-4">Total cost:</div>
                <span className="fs-1">£ {billingData.totalData}</span>
                <span className="fs-5">+VAT</span>
                <div className="text-white fw-normal opacity-50">
                  Lorem ipsum dolor sit amet consectetur.
                </div>
              </div>
            </div>
            <div className="text-white d-flex justify-content-center mb-5 ">
              <div className="text-center m-5 p-2 ">
                <FontAwesomeIcon icon={faCcVisa} size="3x" className="mx-2 " />
                <FontAwesomeIcon icon={faCcPaypal} size="3x" className="mx-2" />
                <FontAwesomeIcon
                  icon={faCcMastercard}
                  size="3x"
                  className="mx-2"
                />
                <FontAwesomeIcon
                  icon={faCcApplePay}
                  size="3x"
                  className="mx-2"
                />
                <div className="mt-2 fw-normal">
                  Lorem ipsum dolor sit amet consectetur adip.
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Checkout;
